// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__Ngvpv"};